var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-multi-select", {
    attrs: {
      fancy: true,
      items: _vm.items,
      label: _vm.$ct(
        _vm.value.length > 0 ? "labels.assigned" : "labels.assign"
      ),
      value: _vm.value,
    },
    on: {
      input: function ($event) {
        return _vm.onInput($event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }